import IResult from './IResult.js';
import Success from "./Success";

const _success: Success = new Success();
let _result: IResult<Success> | null = null;

class ResultInternal<T> implements IResult<T> {
	error: Error | null;
	value: T | null;

	constructor(value: T | null, error: Error | null) {
		this.value = value;
		this.error = error;
	}

	getOrThrow(): T {
		if (this.error == null && this.value != null) {
			return this.value;
		}

		throw this.error;
	}

	choose(successAction: ((arg0: T) => void), errorAction: ((arg0: Error) => void)): void {
		if (this.error != null) {
			errorAction(this.error);
		} else {
			successAction(this.value!);
		}
	}

	match<TResult>(successFunction: ((arg0: T) => TResult), errorFunction: ((arg0: Error) => TResult)): TResult {
		return this.error == null ? successFunction(this.value!) : errorFunction(this.error);
	}
}

export default class Result {
	/**
	 * Creates a new result in the faulted state, using the supplied errorValue as error.
	 * @param errorValue
	 * @returns
	 */
	static fromError<TResult>(errorValue: Error): IResult<TResult> {
		return new ResultInternal<TResult>(null, errorValue);
	}

	/**
	 * Creates a new result in succeeded state, using the supplied successValue as @see {@link Dot: IResult<T>.value}.
	 * @param successValue
	 * @returns
	 */
	static fromValue<TResult>(successValue: TResult): IResult<TResult> {
		return new ResultInternal<TResult>(successValue, null);
	}

	static success(): IResult<Success> {
		return _result ??= new ResultInternal(_success, null);
	}

	/**
	 * Creates a new result in the faulted state, using the supplied errorValue as error.
	 * @param errorValue
	 * @returns
	 */
	static voidFromError(errorValue: Error): IResult<Success> {
		return new ResultInternal(_success, errorValue);
	}
}
